import { matchPath } from 'react-router-dom';
import { history } from 'utils';

export type RedirectOption = { search?: string; state?: { from?: string } };

export const localRedirect = (path: string, params?: RedirectOption) => {
  history.push({
    pathname: path,
    search: params?.search || ''
  });
};

export const isValidPath = (currPath: string, routes: any = {}) => {
  return Object.keys(routes).map(key => {
    return [...routes[key]].some(it => {
      return matchPath(currPath, it);
    });
  });
};

export const getDecodedQueryParams = (searchQuery?: string): object =>
  (searchQuery || window.location.search).split(/\?|&/).reduce((accumulated: {}, current: string): {} => {
    const accumulatedData: any = accumulated;
    if (current) {
      accumulatedData[current.split('=')[0]] = decodeURIComponent(current.split('=')[1]);
    }
    return accumulatedData;
  }, {});

export function getEncodedQueryParams(params: any): any {
  return Object.keys(params)
    .filter((key: string) => Boolean(params[key]))
    .map((key: string): any =>
      [key, encodeURIComponent(typeof params[key] === 'object' ? params[key].value : params[key])].join('=')
    )
    .join('&');
}
